export default {
  paymentHeaderSelectPaymentMethod: '19122018-152801-0041',
  paymentHeaderPaymentMethod: '22022019-142905-0007',
  paymentMethodAccount: '18112016-144902-2130',
  paymentMethodExistingCard: '22022019-142905-0008',
  paymentMethodCard: '23112016-153659-5944',
  paymentMethodNewCard: '30112016-110151-4011',
  paymentMethodOther: '19122018-154639-0781',
  paymentEgyptCurrencyConversionWarning: '19122018-152801-0045',
  paymentAcceptTerms: '19122018-152801-0044',
  paymentErrorIframeExpired: '22022019-142905-0009',
  paymentErrorPaymentFailed: '22022019-142905-0010',
  iAcceptTandC: '21022019-105513-0054',
  paymentAuthorisationAmount: '16122020-101314-7903',
  iAgree: '09032021-141446-0039',
  termsConditions: '18012016-094056-4209',
  and: '22112016-160158-1943',
  termsHouseRules: '09032021-141446-0040',
  privacyPolicy: '18012016-094011-2673',

  paymentErrorCardAddingFailed: ['21022019-105513-0027', { separator: ' ' }, '21112016-165659-1100'],
  paymentCannotGetCardPaymentURLOnlyMethod: ['21022019-105513-0024', { separator: ' ' }, '21022019-105513-0026'],
  paymentCannotGetCardPaymentURL: ['21022019-105513-0024', { separator: ' ' }, '21022019-105513-0025'],
  paymentReservationFailed: '21022019-105513-0029',
  paymentCardDetails: '11112020-141916-0005',
  paymentCardDetailsMessage: '05092025-210045-0000',

  zeroAuthorizationValue: '06052025-121549-4068' // During the registration process, we will submit a zero or low value authorization to your card...
};
